import { Link, SocialShare } from "@quintype/components";
import { object } from "prop-types";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { DfpComponent } from "../../../ads/dfp-component";
import { getStoryDate } from "../../../utils";
import { LiveBlogKeyEvents } from "../liveblog-key-events";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import ShareAllTemplate from "../story-info/story-meta-icons/social-share-template/share-all-template";
import StoryCard from "../story-card";
import StoryInfo from "../story-info";
import { OldStoryMessage } from "../../../atoms/old-stories-message";

import "./story-content.m.css";

const StoryContent = ({ story }) => {
  if (!story) {
    return null;
  }

  const [showPopup, setPopup] = useState(null);
  const [clickId, setclickId] = useState("");
  const [liveStory, setLiveStory] = useState(story);
  const [cardsCount, setCardsCount] = useState(story.cards.length);
  const storyTemplate = get(story, ["story-template"], "");
  const isLiveBlog = storyTemplate === "live-blog";
  const isListicleStory = storyTemplate === "listicle";
  const isVideoStory = storyTemplate === "video";
  const isVideoStory2 = storyTemplate === "video-2";
  const adSlots = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots"], {}));
  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], "en"));
  const enableGoogleAds = get(story, ["metadata", "story-attributes", "enablegoogleads", "0"], "true");

  useEffect(() => {
    if (isLiveBlog && !cardsCount) {
      const cardId = story.cards && story.cards.map((card) => card.id);
      setTimeout(() => {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
      }, 300);

      setLiveStory(story);
      setCardsCount(story.cards.length);

      const storyUpdateId = setInterval(() => updateStory, 30000);

      return () => clearInterval(storyUpdateId);
    }
  }, []);

  const updateStory = async () => {
    const response = await window.fetch(`/api/v1/stories/${story.id}`);
    const jsonResponse = await response.json();
    setLiveStory(jsonResponse.story);
    setCardsCount(jsonResponse.story.cards.length);
  };

  return (
    <div styleName="story-content-wrapper">
      <StoryInfo story={story} />
      {story.cards &&
        (isVideoStory || isVideoStory2 ? story.cards.slice(1) : story.cards).map((card, index) => {
          const Share = (props) => {
            return (
              <button styleName="button" aria-label="social-share">
                <span
                  onClick={() => {
                    setclickId(card.id);
                    setPopup(!showPopup);
                  }}
                >
                  <SvgIconHandler type="black-share" width="24" height="24" viewBox="0 0 24 24" />
                </span>
                {showPopup && clickId === card.id && <ShareAllTemplate setPopup={setPopup} {...props} />}
              </button>
            );
          };
          return (
            <>
              {index === 0
                ? enableGoogleAds === "true" && (
                    <DfpComponent
                      adStyleName={lang === "bn" ? "ad-slot-size-300x100" : "ad-slot-size-300x250-leaderboard"}
                      className="card-ad"
                      id="story-leader-below-hero"
                      path={adSlots.story_leader_below_hero.ad_unit}
                      size={adSlots.story_leader_below_hero.sizes}
                      viewPortSizeMapping={adSlots.story_leader_below_hero.view_port_size_mapping}
                    />
                  )
                : enableGoogleAds === "true" && (
                    <DfpComponent
                      adStyleName="ad-slot-size-300x250"
                      className="card-ad"
                      id={`card-ad-${index + 1}`}
                      path={`/13592525/qt-eng-story-inside-${index}`}
                      size={[[300, 250]]}
                      viewPortSizeMapping={[
                        {
                          viewport: [0, 0],
                          sizes: [[300, 250]],
                        },
                      ]}
                    />
                  )}
              {isLiveBlog && (
                <>
                  {index === 0 &&
                    (!cardsCount ? <LiveBlogKeyEvents story={story} /> : <LiveBlogKeyEvents story={liveStory} />)}
                  <div id={card.id} style={{ display: "flex", justifyContent: "space-between" }}>
                    <div styleName="icon-date-wrapper">
                      <div styleName="icon-wrapper">
                        <SvgIconHandler width="24px" height="24px" type="clock" />
                      </div>
                      {getStoryDate(card["card-added-at"])}
                    </div>
                    <SocialShare
                      template={Share}
                      title={story.headline}
                      fullUrl={encodeURI(`${get(story, ["url"], "")}?cardId=${get(card, ["id"], -1)}`)}
                    />
                  </div>
                  {!cardsCount ? (
                    <StoryCard key={card.id} id={card.id} card={card} story={story} />
                  ) : (
                    <StoryCard key={card.id} id={card.id} card={card} story={liveStory} />
                  )}
                </>
              )}
              {!isLiveBlog &&
                (isListicleStory ? (
                  <div styleName="listicle-card-wrapper">
                    <StoryCard key={card.id} card={card} story={story} />
                  </div>
                ) : (
                  <StoryCard key={card.id} card={card} story={story} />
                ))}
            </>
          );
        })}
      {story.tags.length > 0 && (
        <div styleName="tags-wrapper">
          {story.tags.map((tag, index) => (
            <Link href={"/topic/" + tag.slug} key={index} aria-label="tag">
              <div styleName="tag">{tag.name}</div>
            </Link>
          ))}
        </div>
      )}
      {storyTemplate === "text" ? <OldStoryMessage story={story} /> : null}
    </div>
  );
};

StoryContent.propTypes = {
  story: object,
};

export default StoryContent;
